import { KIDDEE, SITE } from "@/config/sections";
import { KIDDEE_PAGE } from "@/constants/testIds";

const FACTS = ["Rat terrier, 4 years old", "Swims every chance she gets", "Picks her own toys", "Chief Treat Tester"];

export const KiddeeStory = () => (
  <section data-testid={KIDDEE_PAGE.story} className="bg-[#1C1917] text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-20 grid lg:grid-cols-2 gap-10 items-center">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#F5A27F]">Kiddee's story</p>
        <h2 className="font-heading mt-3 text-2xl sm:text-3xl font-extrabold tracking-tight">Smart, fast, and very opinionated.</h2>
        {KIDDEE.story.map((p) => <p key={p.slice(0, 20)} className="mt-4 text-stone-300 leading-relaxed">{p}</p>)}
        <ul className="mt-6 flex flex-wrap gap-2">
          {FACTS.map((f) => <li key={f} className="px-3 py-1.5 rounded-full bg-white/10 text-sm">{f}</li>)}
        </ul>
        <div className="mt-8 flex flex-wrap gap-3">
          {SITE.socials.map((s) => (
            <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={KIDDEE_PAGE.social(s.id)} className="min-h-[44px] inline-flex items-center px-5 rounded-full border border-white/30 text-sm hover:bg-white hover:text-[#1C1917] transition-colors">
              Follow on {s.label}
            </a>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        {KIDDEE.photos.map((src, i) => (
          <img key={src} src={src} alt={`Kiddee the rat terrier, photo ${i + 1}`} loading="lazy" width="400" height="400" className={`w-full aspect-square object-cover rounded-3xl ${i % 2 ? "translate-y-6" : ""}`} />
        ))}
      </div>
    </div>
  </section>
);
